import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { environment } from '@environments/environment';

export type BasePostRequest = {
  update?: number;
  page?: number;
  per_page?: number;
  sorting?: string;
};

export type BaseCreateRequest = {
  sort: Sort;
  paginator?: PageEvent;
  searchControl?: string | null;
};

export type DictionaryItem = {
  id: number;
  name: string;
};

export type PostRequest = BasePostRequest & {
  q?: { [key: string]: any };
};

export type DictionaryRequest = BasePostRequest & {
  q: Record<string, string | boolean>;
  model_name: string;
  company: number | string | null;
};

export type DictionaryList = Array<DictionaryItem>;

export const basePostRequest: PostRequest = {
  page: 1,
  per_page: environment.perPage,
  sorting: '',
  q: {},
};
